import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import csvToJson from 'csvtojson'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        progress: 0,
        progressData: [],
        species: [],
        phenotypeData: null,
        phenotypeHierarchy: null,
        aboutData: null,
        aboutActive: false,
        crowdsourceActive: false,
        neonTitle: null,
        progressTitles: [],
        progressLinks: [],
    },
    mutations: {
        setProgress(state, amt) {
            let newAmt = parseInt(amt, 10)
            if (newAmt < 0) {
                newAmt = 0
            }
            if (newAmt > 3) {
                newAmt = 3
            }
            state.progress = newAmt
        },
        setProgressData(state, progressData) {
            state.progressData = progressData
        },
        setSpecies(state, species) {
            state.species = species
        },
        setPhenotypeData(state, phenotypeData) {
            state.phenotypeData = phenotypeData
        },
        setPhenotypeHierarchy(state, phenotypeHierarchy) {
            state.phenotypeHierarchy = phenotypeHierarchy
        },
        setAboutData(state, aboutData) {
            state.aboutData = aboutData
        },
        setAboutActive(state, aboutActive) {
            state.aboutActive = aboutActive
        },
        setCrowdsourceActive(state, crowdsourceActive) {
            state.crowdsourceActive = crowdsourceActive
        },
        setNeonTitle(state, neonTitle) {
            state.neonTitle = neonTitle
        },
        setProgressLinks(state, progressLinks) {
            state.progressLinks = progressLinks
        },
        setProgressTitles(state, progressTitles) {
            state.progressTitles = progressTitles
        },
    },
    actions: {
        async getSpecies({ commit }) {
            try {
                const { data } = await axios.get('/data/species.json')
                commit('setSpecies', data)
            } catch (err) {
                console.log(err)
            }
        },
        async getProgressData({ commit }) {
            try {
                const { data } = await axios.get('/data/progress.json')
                commit('setProgressData', data)
            } catch (err) {
                console.log(err)
            }
        },
        async getPhenotypeCsvData({ commit }, {folder, types}) {
            try {
                const csvData = (await Promise.all(types.map(async(type) => {
                    const { data } = await axios.get(`${folder}/${type}.csv`)
                    const jsonData = await csvToJson({
                        noheader: true,
                        headers: ['subset', 'name', 'x', 'y'],
                    }).fromString(data)
                    return {[type]: jsonData}
                }))).reduce((sum, type) => ({...sum, ...type}), {})

                commit('setPhenotypeData', csvData)
            } catch (err) {
                console.log(err)
            }
        },
        async getPhenotypeJsonData({ commit }, {folder}) {
            try {
                const { data } = await axios.get(`${folder}/hierarchy.json`)
                commit('setPhenotypeHierarchy', data)
            } catch (err) {
                console.log(err)
            }
        },
        async getAboutData({ commit }) {
            try {
                const { data: progressData } = await axios.get('/data/about.json')
                commit('setAboutData', progressData)
            } catch (err) {
                console.log(err)
            }
        },
    },
})
